import { ContentCard } from '@ctw/shared/components/containers/content-card';
import { DefinitionList } from '@ctw/shared/components/definition-list';
import { allergyData, allergyHistory } from '@ctw/shared/content/allergies/patient-allergies';
import { ResponsiveSourceDocumentLink } from '@ctw/shared/content/CCDA/responsive-source-document-link';
import type { UseResourceDrawerOpenDrawerArgs } from '@ctw/shared/context/resource-drawer-context';
import { tw } from '@ctw/shared/utils/tailwind';
import { capitalize } from 'lodash-es';

export const allergyIntoleranceDrawerAction: UseResourceDrawerOpenDrawerArgs<'AllergyIntolerance'>['action'] =
  ({ model, requestContext }) => ({
    label: 'Allergy / Intolerance',
    title: capitalize(model.display),
    content: {
      body: (
        <div className={tw`flex flex-col gap-5`}>
          <ContentCard
            variant="focal"
            title="Details"
            content={{
              header: <ResponsiveSourceDocumentLink model={model} />,
            }}
          >
            <DefinitionList items={allergyData(model, requestContext.builderId)} />
          </ContentCard>
          {allergyHistory({ model })}
        </div>
      ),
    },
  });
